import { ActionFunction } from 'react-router-dom'

import Community from '@models/Community'
import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const copyToSiteAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const hostname = formData.get('hostname')
  const score_ids = formDataToArray(formData.get('scoreIds'))

  return http.action.post<CopyToSiteResponse>(ApiRoutes.apiCopyScoresToSitePath(), {
    hostname,
    score_ids,
  })
}

export default copyToSiteAction

export type CopyToSiteResponse = {
  community: Community
  count: number
  scores: string[]
  copies: string[]
  failed: string[]
  archive_notify: boolean
}
